import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from 'react';

// 1. Definimos la forma de nuestro contexto
interface SelectionContextType {
  office_id: string;
  setOffice_id: Dispatch<SetStateAction<string>>;
  collect_id: string;
  setCollect_id: Dispatch<SetStateAction<string>>;
  collects: string;
  setCollects: Dispatch<SetStateAction<string>>;
  user_id: string;
  setUser_id: Dispatch<SetStateAction<string>>;
}

// 2. Creamos el contexto (inicialmente podría ser undefined 
//    hasta que lo proveamos con el Provider)
const SelectionContext = createContext<SelectionContextType | undefined>(undefined);

// 3. Creamos un custom hook para consumir el contexto
export const useSelection = (): SelectionContextType => {
  const context = useContext(SelectionContext);
  if (!context) {
    throw new Error('useSelection must be used within a SelectionProvider');
  }
  return context;
};

// 4. Definimos las props del Provider (solo children en este caso)
interface SelectionProviderProps {
  children: ReactNode;
}

// 5. Implementamos el Provider
export const SelectionProvider: React.FC<SelectionProviderProps> = ({ children }) => {
  const [office_id, setOffice_id] = useState<string>('');
  const [collect_id, setCollect_id] = useState<string>('');
  const [user_id, setUser_id] = useState<string>('');
  const [collects, setCollects] = useState<string>('');

  return (
    <SelectionContext.Provider
      value={{
        office_id,
        setOffice_id,
        collect_id,
        setCollect_id,
        user_id,
        setUser_id,
        collects,
        setCollects,
      }}
    >
      {children}
    </SelectionContext.Provider>
  );
};
